import React from 'react';

const SplitText = ({ copy, role, className, classNameSpan, delay }) => {
  return (
    <div style={{ overflow: 'hidden', width: '100%', textAlign: 'center' }}>
      <span className={className} aria-label={copy} role={role}>
        {copy.split('').map(function (char, index) {
          const style = {
            animationDelay: delay
              ? `${delay + 0.5 + index / 15}s`
              : `${0.5 + index / 15}s`
          };
          return (
            <span
              className={classNameSpan}
              aria-hidden="true"
              key={index}
              style={style}
            >
              {char}
            </span>
          );
        })}
      </span>
    </div>
  );
};

export default SplitText;
